export const META_TOKEN_RESET_STATE = 'META_TOKEN_RESET_STATE';
export const META_TOKEN_CURRENT_ITEM = 'META_TOKEN_CURRENT_ITEM';

export const META_TOKEN_REQUEST_LOADING = 'META_TOKEN_REQUEST_LOADING';
export const META_TOKEN_REQUEST_SUCCESS = 'META_TOKEN_REQUEST_SUCCESS';
export const META_TOKEN_REQUEST_FAILED = 'META_TOKEN_REQUEST_FAILED';

export const META_TOKEN_CURRENT_ACTION = 'META_TOKEN_CURRENT_ACTION';
export const META_TOKEN_RESET_ACTION = 'META_TOKEN_RESET_ACTION';